import { getCurrentInstance } from 'vue'

// Vue 3 Composable
export function useDotnet() {
  const instance = getCurrentInstance()

  const processOnRenderErrors = (errors, formObserverRef = null) => {
    const mappedErrors = {}
    errors.forEach((error) => {
      if (error.value.errors[0] && error.value.errors[0].errorMessage) {
        if (error.key) {
          mappedErrors[error.key.toLowerCase()] = Array.isArray(error.value.errors[0].errorMessage) 
            ? error.value.errors[0].errorMessage 
            : [error.value.errors[0].errorMessage]
        } else {
          mappedErrors.generic = Array.isArray(error.value.errors[0].errorMessage) 
            ? error.value.errors[0].errorMessage 
            : [error.value.errors[0].errorMessage]
        }
      }
    })
    
    // If formObserverRef is provided, use it; otherwise try to get from instance refs
    const formObserver = formObserverRef || (instance?.refs?.formObserver)
    if (formObserver && formObserver.setErrors) {
      formObserver.setErrors(mappedErrors)
    }
  }

  return {
    processOnRenderErrors
  }
}

// Vue 2/3 Compatible Mixin (for backward compatibility)
export const DotnetMixin = {
  methods: {
    processOnRenderErrors(errors) {
      const mappedErrors = {}
      errors.forEach((error) => {
        if (error.value.errors[0] && error.value.errors[0].errorMessage) {
          if (error.key) {
            mappedErrors[error.key.toLowerCase()] = Array.isArray(error.value.errors[0].errorMessage) 
              ? error.value.errors[0].errorMessage 
              : [error.value.errors[0].errorMessage]
          } else {
            mappedErrors.generic = Array.isArray(error.value.errors[0].errorMessage) 
              ? error.value.errors[0].errorMessage 
              : [error.value.errors[0].errorMessage]
          }
        }
      })
      this.$refs.formObserver.setErrors(mappedErrors)
    }
  }
}

// Default export for backward compatibility
export default DotnetMixin
